// project imports
import Utils from "./utils"
import * as keys from "./keys"
import { COOKIE_PARA_NAME_FOR_JOURNEY_ID } from "constants/Constants";
import getCookie from "utils/journeyIdCookie/getJourneyId";
import axios from "axios";
import * as APITypes from "../../../../../constants/API";
import moment from "moment";
import OptimizationStore from "../../../../../modules/optimization/store/OptimizationStore";

const FormObserver = (formRef, props) => {
    let biRequest = props.data.bi_request;

    let liAge = Number(biRequest.LI_ENTRY_AGE)
    let policyTerm = biRequest.PR_PT
    let secondaryLaName = biRequest.SecondLifeAssuredName
    let secondaryLaGendar = biRequest.SecondLifeAssuredGender
    let secondaryLaDOB = biRequest.SecondLifeAssuredDOB
    let PT_value = biRequest.PT_VALUE

    formRef.$('plan-option').observe({
        key: 'value',
        call: async ({ field }) => {
            let requestData = {}

            // formRef.$('age-based-withdrawal').set('extra', { ...formRef.$('age-based-withdrawal').extra, hide: true })
            if (Number(field.value.id) === 2) {
                
                OptimizationStore.setSelectedNeed(props.cardKey);
                let journey_id = getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID)
                // let cardKey = Utils.fetchNeedID(props.cardKey)
                OptimizationStore.getEligibleLaList(journey_id, props.cardKey, "CHILD", true, "addsecondary",props?.data?.bi_request?.packageId);
                OptimizationStore.setSelectedNeedCardData(props.data)

                //let data = Utils.fetchMinorDta("1700", 1, "secondary", true)
                // const laListResponse = await axios.post(APITypes.GET_ELIGIBLE_LA_LIST, {
                //     journey_id: getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID),
                //     need_id: Utils.fetchNeedID(props.cardKey),
                //     secondary_la_product: true,
                //     required_la: 'secondary',
                // })
                // console.log("data>>>>", laListResponse?.data)

                // if (laListResponse?.data?.length > 0) {
                //     requestData = {
                //         planOption: field.value.id,
                //         SecondLifeAssuredName: laListResponse?.data[0]?.first_name,
                //         SecondLifeAssuredLastName: laListResponse?.data[0]?.last_name,
                //         SecLaDOB: moment(laListResponse?.data[0]?.dob).format('YYYY-MM-DD'),
                //         secondLifeAssuredGender: laListResponse?.data[0]?.gender === "Male" ? "4" : "5"
                //     }
                //     let gender = laListResponse?.data[0]?.gender === "Male" ? { label: 'Male', id: "4" } : { label: 'Female', id: "5" }

                //     formRef.$('second-life-assured-first-name').set('extra', { ...formRef.$('second-life-assured-first-name').extra, hide: true })
                //     formRef.$('second-life-assured-first-name').set('value', laListResponse?.data[0].first_name)
                //     formRef.$('second-life-assured-last-name').set('extra', { ...formRef.$('second-life-assured-last-name').extra, hide: true })
                //     formRef.$('second-life-assured-last-name').set('value', laListResponse?.data[0].last_name)
                //     formRef.$('second-life-assured-dob').set('extra', { ...formRef.$('second-life-assured-dob').extra, hide: true })
                //     formRef.$('second-life-assured-dob').set('value', laListResponse?.data[0].dob)
                //     formRef.$('second-life-assured-gender').set('extra', { ...formRef.$('second-life-assured-gender').extra, hide: true })
                //     formRef.$('second-life-assured-gender').set('value', gender)
                // } else {
                //     requestData = {
                //         planOption: field.value.id,
                //         SecondLifeAssuredName: "",
                //         SecondLifeAssuredLastName: "",
                //         SecLaDOB: "",
                //         secondLifeAssuredGender: ""
                //     }

                //     formRef.$('second-life-assured-first-name').set('extra', { ...formRef.$('second-life-assured-first-name').extra, hide: true })
                //     formRef.$('second-life-assured-last-name').set('extra', { ...formRef.$('second-life-assured-last-name').extra, hide: true })
                //     formRef.$('second-life-assured-dob').set('extra', { ...formRef.$('second-life-assured-dob').extra, hide: true })
                //     formRef.$('second-life-assured-gender').set('extra', { ...formRef.$('second-life-assured-gender').extra, hide: true })
                // }


            } else {
                requestData = {
                    planOption: field.value.id,
                    SecondLifeAssuredName: "",
                    SecondLifeAssuredLastName: "",
                    SecLaDOB: "",
                    secondLifeAssuredGender: "",
                }
                
                formRef.$('PayorWaiverBenefitRider').set('value', false)
                formRef.$('second-life-assured-first-name').set('extra', { ...formRef.$('second-life-assured-first-name').extra, hide: false })
                formRef.$('second-life-assured-last-name').set('extra', { ...formRef.$('second-life-assured-last-name').extra, hide: false })
                formRef.$('second-life-assured-dob').set('extra', { ...formRef.$('second-life-assured-dob').extra, hide: false })
                formRef.$('second-life-assured-gender').set('extra', { ...formRef.$('second-life-assured-gender').extra, hide: false })
            }
            Utils.updateBi(keys.PLAN_OPTION, requestData, props.data.product_id, formRef, props)
        }
    })

    formRef.$('second-life-assured-first-name').observe({
        key: 'value',
        call: ({ field }) => {

            Utils.updateBi(keys.SECOND_LIFE_ASSURED_NAME, field.value, props.data.product_id, formRef, props)
        }
    })

    formRef.$('second-life-assured-last-name').observe({
        key: 'value',
        call: ({ field }) => {

            Utils.updateBi(keys.SECOND_LIFE_ASSURED_LAST_NAME, field.value, props.data.product_id, formRef, props)

        }
    })

    formRef.$('second-life-assured-dob').observe({
        key: 'value',
        call: ({ field }) => {
            let secondaryLADob = moment(field.value, 'DD-MM-YYYY').format("YYYY-MM-DD")
            Utils.updateBi(keys.SecLaDOB, secondaryLADob, props.data.product_id, formRef, props)
        }
    })

    formRef.$('second-life-assured-gender').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.updateBi(keys.SECOND_LIFE_ASSURED_GENDER, field.value.id, props.data.product_id, formRef, props)

        }
    })




    // !PPT
    formRef.$('premium-term').observe({
        key: 'value',
        call: ({ field }) => {
            // let planOption = Number(formRef.$('plan-option').value.id)
            // let pt = formRef.$('policy-term').value.id
            let ppt = Number(field.value.id)

            // !Income start year
            // let incomeStartYearList = Utils.incomeStartYearOptionList(planOption, Number(field.value.id))
            // formRef.$('income-start-year').set('extra', { ...formRef.$('income-start-year').extra, optionList: incomeStartYearList })
            // if(incomeStartYearList.length > 0) formRef.$('income-start-year').set('value', incomeStartYearList[0])

            // !PT
            // let ptList = Utils.policyTermList(planOption, ppt, liAge)
            // let ptExist = ptList.some((item) => item.id.toString() === policyTerm.toString())
            // formRef.$('policy-term').set('extra', { ...formRef.$('policy-term').extra, optionList: ptList })
            // if (!ptExist) formRef.$('policy-term').set('value', ptList[0])

            // !Life Cover Continuation Benefit
            // let ptValue = pt === '100-@LI_ENTRY_AGE' ? 100 - liAge : Number(pt)
            // let isLifeCoverContinuationBenefitDisabled = Utils.checkLifeCoverDisabled(ppt, ptValue, liAge)
            // formRef.$('life-cover').set('disabled', isLifeCoverContinuationBenefitDisabled)
            // if (isLifeCoverContinuationBenefitDisabled) {
            // 	formRef.$('life-cover').set('value', { label: 'No', id: "10" })
            // }

            let requestData = {
                ppt: field.value.id,
            }

            Utils.updateBi(keys.PR_PPT, requestData, props.data.product_id, formRef, props)
        }
    })

    // !Income start year
    // formRef.$('income-start-year').observe({
    // 	key: 'value',
    // 	call: ({ field }) => {
    // 		Utils.updateBi(keys.INCOME_START_YEAR, field.value.id, props.data.product_id, formRef, props)
    // 	}
    // })

    // !PT
    formRef.$('policy-term').observe({
        key: 'value',
        call: ({ field }) => {

            // !Life Cover Continuation Benefit
            let ppt = formRef.$('premium-term').value.id
            let pt = field.value.id
            let ptValue = pt === '100-@LI_ENTRY_AGE' ? 100 - liAge : Number(pt)
            let isLifeCoverContinuationBenefitDisabled = Utils.checkLifeCoverDisabled(ppt, ptValue, liAge)
            formRef.$('life-cover').set('disabled', isLifeCoverContinuationBenefitDisabled)
            if (isLifeCoverContinuationBenefitDisabled) {
                formRef.$('life-cover').set('value', { label: 'No', id: "10" })
            }

            let requestData = {
                lifeCoverContinuationBenefit: formRef.$('life-cover').value.id,
                pt: field.value.id,
            }

            Utils.updateBi(keys.PR_PT, requestData, props.data.product_id, formRef, props)
        }
    })

    // !Life Cover Continuation Benefit
    // formRef.$('life-cover').observe({
    // 	key: 'value',
    // 	call: ({ field }) => {
    // 		Utils.updateBi(keys.LIFE_COVER_CONTINUATION_BENEFIT, field.value.id, props.data.product_id, formRef, props)
    // 	}
    // })

    // !Payment frequency
    formRef.$('payment-frequency').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.updateBi(keys.FREQUENCY, field.value.id, props.data.product_id, formRef, props)
        }
    })

    // !Accrual Of Survival Benefits
    formRef.$('accrual-of-survival-benefit').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.handleAsbCondition(formRef, field.value.id)
            let asbStartYear1 = ""
            let asbEndYear1 = ""
            let asb2 = ""
            let asbStartYear2 = ""
            let asbEndYear2 = ""
            let asb3 = ""
            let asbStartYear3 = ""
            let asbEndYear3 = ""


            if (field.value.id === 6) {
                Utils.handleASBstartPolicyOneConditions(formRef, props.data.product_name, PT_value, liAge)

                if (formRef.$('asb-start-age-(1st-opt-in)').value) {
                    asbStartYear1 = formRef.$('asb-start-age-(1st-opt-in)').value.id
                }
                if (formRef.$('asb-end-age-(1st-opt-in)').value) {
                    asbEndYear1 = formRef.$('asb-end-age-(1st-opt-in)').value.id
                }
                asb2 = formRef.$('accrual-of-survival-benefits-year-2').value.id
                if (formRef.$('asb-start-age-(2nd-opt-in)').value) {
                    asbStartYear2 = formRef.$('asb-start-age-(2nd-opt-in)').value.id
                }
                if (formRef.$('asb-end-age-(2nd-opt-in)').value) {
                    asbEndYear2 = formRef.$('asb-end-age-(2nd-opt-in)').value.id
                }
                asb3 = formRef.$('accrual-of-survival-benefits-year-3').value.id
                if (formRef.$('asb-start-age-(3rd-opt-in)').value) {
                    asbStartYear3 = formRef.$('asb-start-age-(3rd-opt-in)').value.id
                }
                if (formRef.$('asb-end-age-(3rd-opt-in)').value) {
                    asbEndYear3 = formRef.$('asb-end-age-(3rd-opt-in)').value.id
                }

            }
            let requestData = {
                asb1: field.value.id,
                asbStartYear1,
                asbEndYear1,
                asb2,
                asbStartYear2,
                asbEndYear2,
                asb3,
                asbStartYear3,
                asbEndYear3,
            }
            Utils.updateBi(keys.ACCRUALOFSURVIVALBENEFIT_1, requestData, props.data.product_id, formRef, props)
        }
    })

    formRef.$('asb-start-age-(1st-opt-in)').observe({
        key: 'value',
        call: ({ field }) => {
            let asb2 = ""
            let asbStartYear2 = ""
            let asbEndYear2 = ""
            let asb3 = ""
            let asbStartYear3 = ""
            let asbEndYear3 = ""

            Utils.handleASBFirstStartEndCondition(formRef, formRef.$('accrual-of-survival-benefit').value.id)
            let asbEndYearOneList = Utils.fetchASBendPolicyOne(field.value.id, formRef.$("asb-start-age-(1st-opt-in)").extra.optionList, formRef.$("asb-end-age-(1st-opt-in)").extra.preDefinedOptList)
            formRef.$("asb-end-age-(1st-opt-in)").set("extra", {
                ...formRef.$("asb-end-age-(1st-opt-in)").extra,
                optionList: asbEndYearOneList,
            });
            let selectedAsbEndYearOne = asbEndYearOneList.some((item) => item.id === formRef.$("asb-end-age-(1st-opt-in)").value?.id);
            if (!selectedAsbEndYearOne) {
                let optData = asbEndYearOneList.find((item) => item.label === field.value.label)
                formRef
                    .$("asb-end-age-(1st-opt-in)")
                    .set("value", optData);
            }
            if (Number(field.value.label) === Number(99) || Number(formRef.$("asb-end-age-(1st-opt-in)").value.label) === Number(99)) {
                formRef.$('accrual-of-survival-benefits-year-2').set("disabled", true)
            } else {
                formRef.$('accrual-of-survival-benefits-year-2').set("disabled", false)
            }
            asb2 = formRef.$('accrual-of-survival-benefits-year-2').value.id
            if (formRef.$('asb-start-age-(2nd-opt-in)').value) {
                asbStartYear2 = formRef.$('asb-start-age-(2nd-opt-in)').value.id
            }
            if (formRef.$('asb-end-age-(2nd-opt-in)').value) {
                asbEndYear2 = formRef.$('asb-end-age-(2nd-opt-in)').value.id
            }
            asb3 = formRef.$('accrual-of-survival-benefits-year-3').value.id
            if (formRef.$('asb-start-age-(3rd-opt-in)').value) {
                asbStartYear3 = formRef.$('asb-start-age-(3rd-opt-in)').value.id
            }
            if (formRef.$('asb-end-age-(3rd-opt-in)').value) {
                asbEndYear3 = formRef.$('asb-end-age-(3rd-opt-in)').value.id
            }

            let requestData = {
                asbStart1: field.value.id,
                asbEnd1: formRef.$("asb-end-age-(1st-opt-in)").value.id,
                asb2,
                asbStartYear2,
                asbEndYear2,
                asb3,
                asbStartYear3,
                asbEndYear3,
            }
            Utils.updateBi(keys.ASB_STARTPOLICYYEAR_1, requestData, props.data.product_id, formRef, props)
        }
    })


    formRef.$('asb-end-age-(1st-opt-in)').observe({
        key: 'value',
        call: ({ field }) => {
            let asb2 = ""
            let asbStartYear2 = ""
            let asbEndYear2 = ""
            let asb3 = ""
            let asbStartYear3 = ""
            let asbEndYear3 = ""
            Utils.handleASBFirstStartEndCondition(formRef, formRef.$('accrual-of-survival-benefit').value.id)
            asb2 = formRef.$('accrual-of-survival-benefits-year-2').value.id

            if (Number(field.value.label) >= Number(99) || Number(formRef.$("asb-start-age-(1st-opt-in)").value.label) === Number(99)) {
                formRef.$('accrual-of-survival-benefits-year-2').set("disabled", true)
            } else {
                formRef.$('accrual-of-survival-benefits-year-2').set("disabled", false)
            }
            if (formRef.$('asb-start-age-(2nd-opt-in)').value) {
                asbStartYear2 = formRef.$('asb-start-age-(2nd-opt-in)').value.id
            }
            if (formRef.$('asb-end-age-(2nd-opt-in)').value) {
                asbEndYear2 = formRef.$('asb-end-age-(2nd-opt-in)').value.id
            }
            asb3 = formRef.$('accrual-of-survival-benefits-year-3').value.id
            if (formRef.$('asb-start-age-(3rd-opt-in)').value) {
                asbStartYear3 = formRef.$('asb-start-age-(3rd-opt-in)').value.id
            }
            if (formRef.$('asb-end-age-(3rd-opt-in)').value) {
                asbEndYear3 = formRef.$('asb-end-age-(3rd-opt-in)').value.id
            }
            let requestData = {
                asbEnd1: field.value.id || "",
                asb2,
                asbStartYear2,
                asbEndYear2,
                asb3,
                asbStartYear3,
                asbEndYear3,
            }
            Utils.updateBi(keys.ASB_ENDPOLICYYEAR_1, requestData, props.data.product_id, formRef, props)
        }
    })

    formRef.$('withdrawal-parcentage-1').observe({
        key: 'value',
        call: ({ field }) => {

            Utils.updateBi(keys.ASB_WITHDRAWALPERCENTAGE_1, field.value.id, props.data.product_id, formRef, props)

        }
    })
    formRef.$('accrual-of-survival-benefits-year-2').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.handleAsbTwoCondition(formRef, field.value.id)
            let asbStartYear2 = ""
            let asbEndYear2 = ""
            let asb3 = ""
            let asbStartYear3 = ""
            let asbEndYear3 = ""
            if (field.value.id === 320) {
                Utils.handleASBTwostartPolicyOneConditions(formRef)
                if (formRef.$('asb-start-age-(2nd-opt-in)').value) {
                    asbStartYear2 = formRef.$('asb-start-age-(2nd-opt-in)').value.id
                }
                if (formRef.$('asb-end-age-(2nd-opt-in)').value) {
                    asbEndYear2 = formRef.$('asb-end-age-(2nd-opt-in)').value.id
                }
                asb3 = formRef.$('accrual-of-survival-benefits-year-3').value.id
                if (formRef.$('asb-start-age-(3rd-opt-in)').value) {
                    asbStartYear3 = formRef.$('asb-start-age-(3rd-opt-in)').value.id
                }
                if (formRef.$('asb-end-age-(3rd-opt-in)').value) {
                    asbEndYear3 = formRef.$('asb-end-age-(3rd-opt-in)').value.id
                }

            }
            let requestData = {
                asb2: field.value.id,
                asbStartYear2,
                asbEndYear2,
                asb3,
                asbStartYear3,
                asbEndYear3,
            }
            Utils.updateBi(keys.ACCRUALOFSURVIVALBENEFIT_2, requestData, props.data.product_id, formRef, props)
        }
    })

    formRef.$('asb-start-age-(2nd-opt-in)').observe({
        key: 'value',
        call: ({ field }) => {
            let asb3 = ""
            let asbStartYear3 = ""
            let asbEndYear3 = ""
            Utils.handleASBTwoStartEndCondition(formRef, formRef.$('accrual-of-survival-benefits-year-2').value.id)
            let asbTwoEndYearOneList = Utils.fetchASBendPolicyOne(field.value.id, formRef.$("asb-start-age-(2nd-opt-in)").extra.optionList, formRef.$("asb-end-age-(2nd-opt-in)").extra.preDefinedOptList);
            formRef.$("asb-end-age-(2nd-opt-in)").set("extra", {
                ...formRef.$("asb-end-age-(2nd-opt-in)").extra,
                optionList: asbTwoEndYearOneList,
            });
            let selectedAsbTwoEndYearOne = asbTwoEndYearOneList.some((item) => item.id === formRef.$("asb-end-age-(2nd-opt-in)").value?.id);
            if (!selectedAsbTwoEndYearOne) {
                let optData = asbTwoEndYearOneList.find((item) => item.label === field.value.label)
                formRef
                    .$("asb-end-age-(2nd-opt-in)")
                    .set("value", optData);
            }
            if (Number(field.value.label) === Number(99) || Number(formRef.$("asb-end-age-(2nd-opt-in)").value.label) === Number(99)) {
                formRef.$('accrual-of-survival-benefits-year-3').set("disabled", true)
            } else {
                formRef.$('accrual-of-survival-benefits-year-3').set("disabled", false)
            }
            asb3 = formRef.$('accrual-of-survival-benefits-year-3').value.id
            if (formRef.$('asb-start-age-(3rd-opt-in)').value) {
                asbStartYear3 = formRef.$('asb-start-age-(3rd-opt-in)').value.id
            }
            if (formRef.$('asb-end-age-(3rd-opt-in)').value) {
                asbEndYear3 = formRef.$('asb-end-age-(3rd-opt-in)').value.id
            }

            let requestData = {
                asbStartYear2: field.value.id,
                asbEndYear2: formRef.$("asb-end-age-(2nd-opt-in)").value.id,
                asb3,
                asbStartYear3,
                asbEndYear3,
                asbEndYear3,

            }
            Utils.updateBi(keys.ASB_STARTPOLICYYEAR_2, requestData, props.data.product_id, formRef, props)
        }
    })

    formRef.$('asb-end-age-(2nd-opt-in)').observe({
        key: 'value',
        call: ({ field }) => {
            let asb3 = ""
            let asbStartYear3 = ""
            let asbEndYear3 = ""
            Utils.handleASBTwoStartEndCondition(formRef, formRef.$('accrual-of-survival-benefits-year-2').value.id)
            asb3 = formRef.$('accrual-of-survival-benefits-year-3').value.id
            if (Number(field.value.label) >= Number(99) || Number(formRef.$("asb-start-age-(2nd-opt-in)").value.label) === Number(99)) {
                formRef.$('accrual-of-survival-benefits-year-3').set("disabled", true)
            } else {
                formRef.$('accrual-of-survival-benefits-year-3').set("disabled", false)
            }
            if (formRef.$('asb-start-age-(3rd-opt-in)').value) {
                asbStartYear3 = formRef.$('asb-start-age-(3rd-opt-in)').value.id
            }
            if (formRef.$('asb-end-age-(3rd-opt-in)').value) {
                asbEndYear3 = formRef.$('asb-end-age-(3rd-opt-in)').value.id
            }

            let requestData = {
                asbEndYear2: field.value.id || "",
                asb3,
                asbStartYear3,
                asbEndYear3,
            }
            Utils.updateBi(keys.ASB_ENDPOLICYYEAR_2, requestData, props.data.product_id, formRef, props)
        }
    })

    formRef.$('withdrawal-parcentage-2').observe({
        key: 'value',
        call: ({ field }) => {

            Utils.updateBi(keys.ASB_WITHDRAWALPERCENTAGE_2, field.value.id, props.data.product_id, formRef, props)

        }
    })

    formRef.$('accrual-of-survival-benefits-year-3').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.handleAsbThreeCondition(formRef, field.value.id)
            let asbStartYear3 = ""
            let asbEndYear3 = ""

            if (field.value.id === 625) {
                Utils.handleASBThreestartPolicyOneConditions(formRef)
                if (formRef.$('asb-start-age-(3rd-opt-in)').value) {
                    asbStartYear3 = formRef.$('asb-start-age-(3rd-opt-in)').value.id
                }
                if (formRef.$('asb-end-age-(3rd-opt-in)').value) {
                    asbEndYear3 = formRef.$('asb-end-age-(3rd-opt-in)').value.id
                }

            }
            let requestData = {
                asb3: field.value.id,
                asbStartYear3,
                asbEndYear3,
            }
            Utils.updateBi(keys.ACCRUALOFSURVIVALBENEFIT_3, requestData, props.data.product_id, formRef, props)
        }
    })

    formRef.$('asb-start-age-(3rd-opt-in)').observe({
        key: 'value',
        call: ({ field }) => {
            let asbThreeEndYearOneList = Utils.fetchASBendPolicyOne(field.value.id, formRef.$("asb-start-age-(3rd-opt-in)").extra.optionList, formRef.$("asb-end-age-(3rd-opt-in)").extra.preDefinedOptList);
            formRef.$("asb-end-age-(3rd-opt-in)").set("extra", {
                ...formRef.$("asb-end-age-(3rd-opt-in)").extra,
                optionList: asbThreeEndYearOneList,
            });
            let selectedAsbThreeEndYearOne = asbThreeEndYearOneList.some((item) => item.id === formRef.$("asb-end-age-(3rd-opt-in)").value?.id);
            if (!selectedAsbThreeEndYearOne) {
                let optData = asbThreeEndYearOneList.find((item) => item.label === field.value.label)
                formRef
                    .$("asb-end-age-(3rd-opt-in)")
                    .set("value", optData);
            }

            let requestData = {
                asbStartYear3: field.value.id || "",
                asbEndYear3: formRef.$("asb-end-age-(3rd-opt-in)").value.id,

            }
            Utils.updateBi(keys.ASB_STARTPOLICYYEAR_3, requestData, props.data.product_id, formRef, props)
        }
    })

    formRef.$('asb-end-age-(3rd-opt-in)').observe({
        key: 'value',
        call: ({ field }) => {
            let requestData = {
                asbEndYear3: field.value.id || "",
            }
            Utils.updateBi(keys.ASB_ENDPOLICYYEAR_3, requestData, props.data.product_id, formRef, props)
        }
    })

    formRef.$('withdrawal-parcentage-3').observe({
        key: 'value',
        call: ({ field }) => {

            Utils.updateBi(keys.ASB_WITHDRAWALPERCENTAGE_3, field.value.id, props.data.product_id, formRef, props)

        }
    })


    // Addtional Rider

    formRef.$('ADB').observe({
        key: 'value',
        call: ({ field }) => {
            let adbValue = formRef.$('ADB-dropdown').value
            Utils.updateBi(keys.ADB_RIDER, adbValue, props.data.product_id, formRef, props)
        }
    })

    formRef.$('ATPDRider').observe({
        key: 'value',
        call: ({ field }) => {
            let atpdValue = formRef.$('ATPDRider-dropdown').value
            Utils.updateBi(keys.ATPD_RIDER, atpdValue, props.data.product_id, formRef, props)
        }
    })

    formRef.$('CriticalIllnessRider').observe({
        key: 'value',
        call: ({ field }) => {
            let criticalIllness = formRef.$('CriticalIllnessRider-dropdown').value
            Utils.updateBi(keys.Critical_ILLNESS_RIDER, criticalIllness, props.data.product_id, formRef, props)
        }
    })

    formRef.$('IncomeBenefitRider').observe({
        key: 'value',
        call: ({ field }) => {
            let incomeBuilder = formRef.$('IncomeBenefitRider-dropdown').value
            Utils.updateBi(keys.INCOME_BENEFIT_RIDER, incomeBuilder, props.data.product_id, formRef, props)
        }
    })

    formRef.$('PayorWaiverBenefitRider-dropdown').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.updateBi(keys.PWB_RIDER, field.value.id, props.data.product_id, formRef, props)
        }
    })

}

export default FormObserver
